document.addEventListener("DOMContentLoaded", function () {

    const randomSections = Array.from(document.querySelectorAll(
        'section[data-section-type="featured-collection"][data-randomize="true"]'
    ));

    if (randomSections.length < 2) return;

    const randomIndex = Math.floor(Math.random() * randomSections.length);

    randomSections.forEach((sec, idx) => {
        sec.style.display = idx === randomIndex ? "block" : "none";
    });
});
